/**
 * Usage:
 *
 * Step 1: Somewhere in JS...
 *   import Alpine from "alpinejs";
 *   import spine from "./swiper";
 *   Alpine.data('swiper', swiper);
 *   Alpine.start();
 *
 * Step 2: Somewhere in markup...
 *   <div x-data="...swiper({
            slidesPerView:1,
            })}" />
 *
 * @returns {{init(): void, el: null, selector: null}}
 */

// import any additional classes such as { Pagination }
import Swiper from 'swiper';
import { Autoplay, Scrollbar, EffectFade, Pagination } from 'swiper/modules';

import 'swiper/css/bundle';
// initialize any additional classes such as { Pagination }
Swiper.use([Autoplay, Scrollbar, EffectFade, Pagination]);

export default (opts = {}) => ({
  options : {
    centerInsufficientSlides : true,
    speed: 2000,
    ...opts
  },
  swiper : null,

  init() {
    if(this.swiper !== null) return;
    this.swiper = new Swiper(this.$el, this.options);
  }
});